import './';

/* eslint-disable no-console */
if (console && console.log && typeof console.log === 'function') {
	console.log('Sidekick: Redirected from https://app.frontlineeducation.com/sidekick.js');
}
/* eslint-enable no-console */
